export default __webpack_public_path__ + "static/media/tapestry.b0f9549f.png";